export default {
  SET_ROLE_LIST(state, data) {
    state.roleList = data
  },

  SET_MODULE_LIST(state, data) {
    state.moduleList = data
  },

  SET_MODULE_LIST_CHILDREN(state, data) {
    state.moduleListChildren = data
  },
}